import { render, staticRenderFns } from "./TmplAdmin.vue?vue&type=template&id=1a9de44b&"
import script from "./TmplAdmin.vue?vue&type=script&lang=js&"
export * from "./TmplAdmin.vue?vue&type=script&lang=js&"
import style0 from "./TmplAdmin.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports